/**
 * Compliance item attachment schemas.
 */

import { z } from "zod";
import { idSchema, iso8601Schema } from "./common";

export const complianceItemAttachmentOutputSchema = z.object({
  id: idSchema,
  itemId: idSchema,
  uploadedById: idSchema,
  fileName: z.string().min(1).max(255),
  fileUrl: z.string().url().max(2048),
  storagePath: z.string().max(512).nullable().optional(),
  fileSize: z.number().int().nonnegative(),
  mimeType: z.string().max(128).nullable(),
  uploadedAt: iso8601Schema,
  deletedAt: iso8601Schema.nullable(),
});
export type ComplianceItemAttachmentOutput = z.infer<typeof complianceItemAttachmentOutputSchema>;

export const createComplianceItemAttachmentInputSchema = z.object({
  fileName: z.string().min(1).max(255),
  fileUrl: z.string().url().max(2048),
  fileSize: z.number().int().nonnegative(),
  mimeType: z.string().max(128).nullable().optional(),
});
export type CreateComplianceItemAttachmentInput = z.infer<typeof createComplianceItemAttachmentInputSchema>;
